module.exports = __webpack_public_path__ + "img/voice-icon.56865595.png";